import {
    QueryKey,
    UndefinedInitialDataOptions,
    useQuery,
} from '@tanstack/react-query';
import { useEffect } from 'react';

interface Options<T, Error>
    extends UndefinedInitialDataOptions<
        T | undefined,
        Error,
        T | undefined,
        QueryKey
    > {
    onSuccess?: (data: T) => void;
}

export function useQueryWithCallback<T, Error>({
    onSuccess,
    ...options
}: Options<T, Error>) {
    const result = useQuery({ ...options });

    useEffect(() => {
        if (result.isSuccess && typeof result.data !== 'undefined') {
            onSuccess?.(result.data);
        }
    }, [onSuccess, result.data, result.isSuccess]);

    return result;
}
